import * as React from 'react';
export const IcStatusLoading = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.11 13.24A8.23 8.23 0 014 12a8.23 8.23 0 01.11-1.24 1.012 1.012 0 00-2-.31 9.31 9.31 0 000 3.1 1 1 0 001 .85h.15a1.001 1.001 0 00.85-1.16zm1.31 3.31a1.001 1.001 0 00-1.863.354 1 1 0 00.223.776A9.93 9.93 0 006 20a1 1 0 001.18.012 1 1 0 00.03-1.602 8.06 8.06 0 01-1.79-1.86zM12 2a10.3 10.3 0 00-2 .2 1.02 1.02 0 10.4 2A7.85 7.85 0 0112 4a8 8 0 010 16 7.85 7.85 0 01-1.61-.16 1.019 1.019 0 10-.4 2 10.3 10.3 0 002 .2A10.02 10.02 0 0012 2zM6 4.05a9.93 9.93 0 00-2.22 2.27A1 1 0 004 7.71a1 1 0 001.39-.26 8.06 8.06 0 011.77-1.81A1 1 0 106 4.05z'
      fill='currentColor'
    />
  </svg>
);
